export default __webpack_public_path__ + "static/media/detail_icon.81897baf.svg";